import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "./authConfig";

export default function RequireAuth({ children }) {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const accounts = instance.getAllAccounts();

      if (accounts.length === 0) {
        navigate("/admin-login", { replace: true });
        return;
      }

      try {
        await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
      } catch (err) {
        console.warn("Silent token failed", err);
        navigate("/admin-login", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [instance, navigate]);

  if (loading) return <div>Loading...</div>;

  return <>{children}</>;
}
